module.exports = __webpack_public_path__ + "img/49.5399bba1.png";